import update from 'immutability-helper';

export default function setGettingMapData(state, action) {
  // console.log('SET_GETTING_MAP_DATA', action)

  return update(state, {
    gettingMap: {
      $set: true,
    },
  });
}
